// BEM NAMES
export const PRODUCT_BLOCK = 'product';
export const PRICE_BLOCK = 'price';
export const RANGE_BLOCK = 'range';
export const CURRENT_PRICE_ELEMENT = `${PRICE_BLOCK}__sale`;
export const REGULAR_PRICE_ELEMENT = `${PRICE_BLOCK}__retail`;
export const SALE_DISCOUNT_PRICE_ELEMENT = `${CURRENT_PRICE_ELEMENT}__discount`;
export const DELIVERY_DATE_BLOCK = 'delivery-date';
export const STOCK_DATE_BLOCK = 'stock-date';
export const ADD_TO_LIST_BLOCK = 'add-to-list';
export const SIZE_BLOCK_ELEMENT = `${PRODUCT_BLOCK}__size`;

// DATA PROPERTY NAMES
export const PRICE = 'price';
export const REGULAR_PRICE = 'regular-price';
export const PRICE_FORMATTED = 'price-formatted';
export const REGULAR_PRICE_FORMATTED = 'regular-price-formatted';
export const SALE_DISCOUNT_PRICE_FORMATTED = 'sale-discount-price-formatted';
export const SKIP_PRICE_UPDATE = 'skipPriceUpdate';



// WEBPACK FOOTER //
// ./styleguide/src/assets/lib/constants/pdp.js